export default __webpack_public_path__ + "static/media/C_Cachorro.ff6d81f7.svg";